import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgX = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 24,
		height: 24,
		rx: 12,
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M6.03127 6L11.0504 12.6186L6 18H7.13697L11.559 13.2888L15.1316 18H19L13.6987 11.0091L18.3999 6H17.2629L13.1909 10.339L9.90046 6H6.03202H6.03127ZM7.70278 6.82582H9.47953L17.327 17.1742H15.5502L7.70278 6.82582Z",
		fill: "white"
	})]
});
export default SvgX;
